import React from 'react';
import { FaPlus } from 'react-icons/fa';

const CustomModal = ({ isOpen, onClose, children, title }) => {
    if (!isOpen) return null;

    return (
        <div
            className="modal fade show d-block"
            tabIndex="-1"
            style={{
                background: 'rgba(0,0,0,0.5)',
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: 1050
            }}
            onClick={onClose}
        >
            <div
                className="modal-dialog"
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '90%',
                    maxWidth: '500px',
                    borderRadius: '20px'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <div
                    className="modal-content"
                    style={{
                        backgroundColor: 'white',
                        borderRadius: '20px',
                        border: 'none',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
                    }}
                >
                    {title && (
                        <div className="modal-header" style={{ borderBottom: 'none', padding: '20px', backgroundColor: '#F1EBE8', borderTopLeftRadius: '20px', borderTopRightRadius: '20px' }}>
                            <h5 className="modal-title" style={{ color: '#1D244C', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <FaPlus style={{ color: '#1D244C' }} />
                                {title}
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={onClose}
                                style={{ background: 'none', border: 'none', fontSize: '20px', color: '#1D244C' }}
                            >
                                ×
                            </button>
                        </div>
                    )}
                    <div className="modal-body" style={{ padding: '20px', borderBottomLeftRadius: '20px', borderBottomRightRadius: '20px' }}>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CustomModal;